import { useRef, useEffect } from 'react';

export default () => {
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
  }, []);
  return mounted.current;
};
